import { makeAutoObservable } from "mobx";
import { onError } from "@/utils/onError";
export class SingleManufacturerStore {
    constructor(manufacturerService) {
        this.manufacturerService = manufacturerService;
        this.manufacturer = null;
        this.loading = false;
        makeAutoObservable(this);
    }
    setManufacturer(manufacturer) {
        this.manufacturer = manufacturer;
    }
    setLoading(loading) {
        this.loading = loading;
    }
    async init(manufacturerId) {
        this.setLoading(true);
        try {
            const manufacturers = manufacturerId
                ? await this.manufacturerService.getManufacturersByIds([manufacturerId])
                : null;
            this.setManufacturer(manufacturers?.[0] || null);
        }
        catch (error) {
            onError(error, "Error initializing manufacturer");
        }
        finally {
            this.setLoading(false);
        }
    }
    async saveManufacturer(manufacturerData) {
        try {
            this.setLoading(true);
            const task = this.manufacturer
                ? this.manufacturerService.updateManufacturer(this.manufacturer.id, manufacturerData)
                : this.manufacturerService.createManufacturer(manufacturerData);
            this.setManufacturer(await task);
            return this.manufacturer;
        }
        catch (error) {
            onError(error, "Error saving manufacturer");
            return null;
        }
        finally {
            this.setLoading(false);
        }
    }
    async deleteManufacturer(manufacturerId) {
        this.setLoading(true);
        try {
            await this.manufacturerService.deleteManufacturer(manufacturerId);
            this.setManufacturer(null);
        }
        catch (error) {
            onError(error, "Failed to delete manufacturer");
        }
        finally {
            this.setLoading(false);
        }
    }
    clearManufacturerData() {
        this.setManufacturer(null);
        this.setLoading(false);
    }
}
